import React,{useState,useCallback,useEffect} from 'react'
import { GetCategories } from '../Services/ApiFunction';
import Navbar from '../Components/Navbar';
import Carousel from '../Components/Carousel';
import CategoryDivCarousel from '../Components/CategoryDivCarousel';
import classes from './Home.module.css'
import Lottie from 'lottie-react';
import loader from '../Animations/Loader.json'
import { v4 as uuidv4 } from 'uuid';
import Cookies from 'js-cookie';
import axios from 'axios'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate,useParams } from 'react-router-dom';
import { check_subscription_api } from '../Services/Apis';
import { generateRandomString } from '../Components/RandomStringGenerator';


const Home = () => {

  const [categories,setCategories] = useState([]);
  const [loading,setLoading] = useState(false);

  const {artist} = useParams();
  console.log(artist)

   const number = Cookies.get('sub_number')

   const params = new URLSearchParams(window.location.search)
    const extId = params.get('ext_ref') || generateRandomString();

    const navigate = useNavigate()
 


  const fetchCategories = useCallback(
    async() => {
      setLoading(true);
      try{
        const res = await GetCategories();
        if (res && Array.isArray(res)) {
          setCategories(res);
        }
      }
      catch(err){
        console.log(err);
      }
      setLoading(false)
    },
    []
  )

  useEffect(()=>{
    fetchCategories()
  },[fetchCategories])

  

  useEffect(()=>{
      window.scrollTo({
        top: 0, // Scroll to the top
        behavior: 'smooth', // Adds a smooth scrolling effect
      });
    },[])



    const checkSubscription=async()=>{
      if(!number){
          setTimeout(()=>{
            window.location.href = `http://seenvd.com/api/header?ext_ref=${extId}`
          },10000)
          return;
      }
      setLoading(true)

      // try {
      //     const response = await axios.get(`${check_subscription_api}?msisdn=${number}`);
      //     setLoading(false);
      //     toast.success(response.data)
      //   } 
      //   catch (error) {
      //     // toast.error(error.response.data)
      //     setLoading(false);
      //     setTimeout(()=>{
      //       navigate('/subscribe')
      //     },10000)
      //   }
        
      };


      useEffect(()=>{
         checkSubscription()
      },[])

  return (
    <>
    {
      loading ? 
      <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh', // ✅ Makes it fill the screen
    width: '100vw',
    
  }}>
      <Lottie 
        animationData={loader}
        style={{ height:'50%',width:'100%' }} 
      />
      </div>
       :
    
    <div>
    <Navbar Categories={categories}/>
    <div className={classes.main}>
    <div className={classes.carousel}>
    <Carousel/>
    </div>
    {/* <div className={classes.category_div}>
      <CategoryDivCarousel category="Explore"/>
        </div> */}
    {
      Array.isArray(categories) && categories.length>0 && 
      categories.map((category,idx)=>{
        {/* const catName = category?.cat_name || 'Yoga'; */}
        return(
        <div className={classes.category_div} key={idx}>
      <CategoryDivCarousel category={category || 'Yoga'}  artist={artist} />
        </div>
      ) 

      })
    }
    
    </div>
    </div>
  }
    </>
  )
}

export default Home
